module.exports = __webpack_public_path__ + "static/media/Тицкая Анастасия Витальевна Сквозь века с датским принцем в сердце Вологодская обл.-1.png";